import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SearchPage from './components/SearchPage';
import VotingMachine from './components/VotingMachine';
import Login from './components/Login';
import CMS from './components/CMS';

function App() {
  // Detect subdomain
  const hostname = window.location.hostname;
  // Check for vote subdomain (vote.wagaskar.in or votemachine.wagaskar.in)
  // votersearch.wagaskar.in should show search page
  const isVoteMachine = hostname.includes('vote.wagaskar') || hostname.includes('votemachine');

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {isVoteMachine ? (
            <>
              <Route path="/" element={<Navigate to="/voting" replace />} />
              <Route path="/voting" element={<VotingMachine />} />
            </>
          ) : (
            <>
              <Route path="/" element={<SearchPage />} />
              <Route path="/voting" element={<VotingMachine />} />
            </>
          )}
          <Route path="/login" element={<Login />} />
          <Route path="/cms" element={<CMS />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
